import { module as BaseModule } from 'modujs';
import Swiper from 'swiper';
import {
  Controller,
  EffectCreative,
  EffectFade,
  Navigation
} from 'swiper/modules';

import { getVimeoId, getYouTubeId } from '../utils/video';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        openVideo: 'showTestimonialVideo',
      }
    };

    this.resizeObserver = null;
    this.sliderTestimonials = null;
    this.sliderImages = null;

    this.modal = this.$('videoModal')[0];
    this.videoContainer = this.$('videoContainer')[0];
    this.closeModal = this.$('closeModal')[0];
  }

  showTestimonialVideo( event ) {
    const videoURL = event.target.dataset.videoTestimonialUrl;
    if ( videoURL.includes('youtube.com') ) {
      let youtube = getYouTubeId( videoURL );
      this.videoContainer.src = `https://www.youtube.com/embed/${youtube.videoId}?autoplay=1&color=white`;
    } else if ( videoURL.includes('vimeo.com') ) {
      let vimeo = getVimeoId( videoURL );
      // Check the presence of hash for unlisted videos
      if ( typeof vimeo.hash !== 'undefined' ) {
        this.videoContainer.src = `https://player.vimeo.com/video/${vimeo.videoId}?h=${vimeo.hash}&autoplay=1&title=0&byline=0&portrait=0`;
      } else {
        this.videoContainer.src = `https://player.vimeo.com/video/${vimeo.videoId}?autoplay=1&title=0&byline=0&portrait=0`;
      }
    }
    this.modal.showModal();
  }

  initSliders() {
    this.sliderTestimonials = new Swiper( this.$('slider')[0], {
      modules: [ Controller, EffectFade, Navigation ],
      speed: 1000,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    } );

    this.sliderImages = new Swiper( this.$('slider')[1], {
      modules: [ EffectCreative ],
      speed: 1000,
      slidesPerView: 1,
      allowTouchMove: false,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          translate: [ 0, 0, -250 ], // experiment 1
          origin: 'top center',
        },
        next: {
          opacity: 0,
          translate: [ '150%', 0, -250 ], // experiment 1
          origin: 'bottom center',
        },
      },
      on: {
        init: swiper => {
          setTimeout(() => {
            swiper.el.classList.add('slider-images-visible');
          }, 300);
        },
      },
      limitProgress: 1,
      progressMultiplier: 1000,
      //shadowPerProgress: true,
    } );

    this.sliderTestimonials.controller.control = this.sliderImages;
    //this.sliderImages.controller.control = this.sliderTestimonials;
  }

  initSliderWithOptions(slider, options) {
    console.log( slider, options );
  }

  setupOpenCloseAnimation() {
    const originalShowModal = this.modal.showModal;
    const originalClose = this.modal.close;

    this.modal.showModal = () => {
      originalShowModal.call(this.modal);
      this.modal.classList.add('is-open');
    };

    this.modal.close = () => {
      this.modal.addEventListener(
        'transitionend',
        ev => {
          originalClose.call(this.modal)
        },
        {once: true}
      );
      this.modal.classList.remove('is-open');
    }
  }

  initEvents() {
    // As this event is not cancellable,
    // just remove the class; cannot do the animation.
    this.modal.addEventListener('close', ev => {
      this.videoContainer.src = '';
    });

    // Close the modal when clicking the overlay
    this.modal.addEventListener('click', ev => {
      const dialogDimensions = this.modal.getBoundingClientRect();
      if (
        ev.target.nodeName === 'DIALOG' &&
        (
          ev.clientX < dialogDimensions.left ||
          ev.clientX > dialogDimensions.right ||
          ev.clientY < dialogDimensions.top ||
          ev.clientY > dialogDimensions.bottom
        )
      ) {
        this.modal.close();
      }
    });

    // Enable the close button
    this.closeModal.addEventListener('click', ev => {
      this.modal.close();
    })
  }
  init() {
    this.setupOpenCloseAnimation();
    this.initEvents();
    this.initSliders();
  }
}
